import axios from 'axios';

// Consigli: suggerimenti generati di notte dai dati del negozio (features/insights nel backend)
const state = {
	items: [],
	summary: null,
	radar: [],
};

const getters = {
	getItems: state => state.items,
	getSummary: state => state.summary,
	getRadar: state => state.radar,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const filters = settings.filters || {};
		return axios
			.post(
				url(context, 'insights'),
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0] ? 1 : 0,
						page,
						itemsPerPage,
						search: settings.search,
						type: filters.type || '',
						area: filters.area || '',
						status: filters.status || 'open',
					},
				},
				auth(context),
			)
			.then(res => {
				context.commit('setItems', res.data.data);
				return res.data.pagination;
			})
			.catch(err => console.log('errore', err));
	},
	fetchSummary: async context => {
		const res = await axios.get(url(context, 'insights/summary'), auth(context));
		context.commit('setSummary', res.data.data);
		return res.data.data;
	},
	fetchRadar: async context => {
		const res = await axios.get(url(context, 'insights/radar'), auth(context));
		context.commit('setRadar', res.data.data);
		return res.data.data;
	},
	setStatus: async (context, { item, status, snoozeDays }) => (await axios.put(url(context, `insights/${item._id}`), { status, snoozeDays }, auth(context))).data.data,
	// simulatore "e se": { scope, lever, days } -> stima con intervallo (niente stato nello store, la pagina tiene il risultato)
	simulate: async (context, payload) => (await axios.post(url(context, 'insights/simulate'), payload, auth(context))).data.data,
	refresh: async context => (await axios.post(url(context, 'insights/refresh'), {}, auth(context))).data.data,
	// consigli del singolo prodotto (card nella modifica prodotto): { item, refresh? }
	fetchItemAdvice: async (context, params) => (await axios.get(url(context, 'insights/item'), { ...auth(context), params })).data.data,
	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setSummary', null);
		context.commit('setRadar', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value || [];
	},
	setSummary: (state, value) => {
		state.summary = value;
	},
	setRadar: (state, value) => {
		state.radar = value || [];
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
